import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
// import store from '@/store'
import iView from 'iview'
// import { canTurnTo } from '@/libs/util'

Vue.use(Router)
const router = new Router({
  routes,
  mode: 'history'
})
// const LOGIN_PAGE_NAME = 'login'

// const turnTo = (to, access, next) => {
//   if (canTurnTo(to.name, access, routes)) next() // 有权限，可访问
//   else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
// }

router.beforeEach((to, from, next) => {
  // var access = []
  // try {
  //   access = localStorage.getItem('access') ? JSON.parse(localStorage.getItem('access')) : []
  // } catch (e) {
  //   access = []
  // }
  iView.LoadingBar.start()
  if (to.name !== 'error_401' && to.name !== 'error_500' && to.name !== 'error_404') {
    // let isAdmin = localStorage.getItem('isAdmin')
    next()
    // turnTo(to.name, isAdmin, next)
  } else {
    next()
  }
  next()
})

router.afterEach(to => {
  // setTitle(to, router.app)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
